import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/useAuth';

export function RequireAdmin() {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="font-heading text-2xl text-brand-dark mb-2">Access Denied</h1>
          <p className="text-text-muted">
            You do not have permission to access the admin dashboard.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
